import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { CpWidgetVariantType } from 'api/customer-portal/types';
import { CpSectionWrapper } from 'components/organisms/customer-portal/widgets/common';
import {
  CtaCenterAlignedWrapper,
  CtaCenterAlignedSectionWrapper,
  CtaCenterAlignedContentWrapper,
  CtaCenterAlignedButtonWrapper,
} from 'components/organisms/customer-portal/widgets/cta/variants/cp-cta-center-aligned';
import {
  CTALeftAlignedWrapper,
  CTALeftAlignedSectionWrapper,
  CTALeftAlignedContentWrapper,
  CTALeftAlignedButtonWrapper,
} from 'components/organisms/customer-portal/widgets/cta/variants/cp-cta-left-aligned';
import {
  CpCTAStretchedWrapper,
  CpCTAStretchedContentWrapper,
} from 'components/organisms/customer-portal/widgets/cta/variants/cp-cta-stretched';
import {
  CTAStretchedWithBackgroundWrapper,
  CTAStretchedWithBackgroundContentWrapper,
} from 'components/organisms/customer-portal/widgets/cta/variants/cp-cta-stretched-with-background';
import {
  CTATitleAndContentSectionWrapper,
  CTATitleAndContentSectionSectionWrapper,
} from 'components/organisms/customer-portal/widgets/cta/variants/cp-cta-title-and-content-section';
import { CpLoadingProps } from '../common';

const Title = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    max-width: 100% !important;
    width: 672px !important;
    height: 37px !important;

    @media (max-width: 768px) {
      width: 312px !important;
      height: 60px !important;
    }

    @media (max-width: 480px) {
      width: 292px !important;
      height: 51px !important;
    }
  }

  &.ant-skeleton-button,
  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
    height: 100% !important;
    width: 100% !important;
  }
`;

const Desc = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    max-width: 100% !important;
    width: 672px !important;
    height: 57px !important;

    @media (max-width: 768px) {
      width: 312px !important;
      height: 102px !important;
    }

    @media (max-width: 480px) {
      width: 292px !important;
      height: 102px !important;
    }
  }

  &.ant-skeleton-button,
  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
    height: 100% !important;
    width: 100% !important;
  }
`;

const Button = styled(Skeleton.Button)`
  .ant-skeleton,
  &.ant-skeleton,
  & {
    max-width: 100% !important;
    width: 154px !important;
    height: 40px !important;
  }

  &.ant-skeleton-button,
  .ant-skeleton-button {
    border-radius: var(--border-radius-default);
    height: 100% !important;
    width: 100% !important;
  }
`;

const StyledButtonWrapper = styled(CTALeftAlignedButtonWrapper)`
  @media (max-width: 480px) {
    align-items: center;
  }
`;

const StyledCenterAlignedButtonWrapper = styled(CtaCenterAlignedButtonWrapper)`
  @media (max-width: 480px) {
    align-items: center;
  }
`;

const Content: React.FC<{ variantType: string }> = ({ variantType }) => {
  switch (variantType) {
    case CpWidgetVariantType.CTALeftAligned:
      return (
        <CTALeftAlignedWrapper>
          <CTALeftAlignedSectionWrapper>
            <CTALeftAlignedContentWrapper>
              <Title active />
              <Desc active />
            </CTALeftAlignedContentWrapper>

            <StyledButtonWrapper>
              <Button active />
              <Button active />
            </StyledButtonWrapper>
          </CTALeftAlignedSectionWrapper>
        </CTALeftAlignedWrapper>
      );

    case CpWidgetVariantType.CTACenterAligned:
      return (
        <CtaCenterAlignedWrapper>
          <CtaCenterAlignedSectionWrapper>
            <CtaCenterAlignedContentWrapper>
              <Title active />
              <Desc active />
            </CtaCenterAlignedContentWrapper>

            <StyledCenterAlignedButtonWrapper>
              <Button active />
              <Button active />
            </StyledCenterAlignedButtonWrapper>
          </CtaCenterAlignedSectionWrapper>
        </CtaCenterAlignedWrapper>
      );

    case CpWidgetVariantType.CTAStretched:
      return (
        <CpCTAStretchedWrapper>
          <CpCTAStretchedContentWrapper>
            <Title active />
            <Desc active />
          </CpCTAStretchedContentWrapper>

          <StyledButtonWrapper>
            <Button active />
            <Button active />
          </StyledButtonWrapper>
        </CpCTAStretchedWrapper>
      );

    case CpWidgetVariantType.CTAStretchedWithBackground:
      return (
        <CTAStretchedWithBackgroundWrapper>
          <CTAStretchedWithBackgroundContentWrapper>
            <Title active />
            <Desc active />
          </CTAStretchedWithBackgroundContentWrapper>

          <StyledButtonWrapper>
            <Button active />
            <Button active />
          </StyledButtonWrapper>
        </CTAStretchedWithBackgroundWrapper>
      );

    case CpWidgetVariantType.CTATitleAndContentSection:
      return (
        <CTATitleAndContentSectionWrapper>
          <CTATitleAndContentSectionSectionWrapper>
            <Title active />
          </CTATitleAndContentSectionSectionWrapper>
          <CTATitleAndContentSectionSectionWrapper>
            <Desc active />

            <StyledButtonWrapper>
              <Button active />
              <Button active />
            </StyledButtonWrapper>
          </CTATitleAndContentSectionSectionWrapper>
        </CTATitleAndContentSectionWrapper>
      );

    default:
      return <></>;
  }
};

export const CpCtaLoading: React.FC<CpLoadingProps> = ({
  variantType,
  styles,
}) => {
  return (
    <CpSectionWrapper
      background={styles?.background as string}
      paddingY={styles?.paddingY as number | undefined}
      className="!cp-max-w-none"
    >
      <Content variantType={variantType} />
    </CpSectionWrapper>
  );
};
